import { render, staticRenderFns } from "./switchMainAudit.vue?vue&type=template&id=52437b28&scoped=true"
import script from "./switchMainAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./switchMainAudit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52437b28",
  null
  
)

export default component.exports